import React from 'react';
import PropTypes from 'prop-types';

const TemplateStore = require('../../stores/template_store_reflux');
const verUtil = require('../../util/version.js');
const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    className: PropTypes.string,
    activity: PropTypes.shape({ template_id: PropTypes.number.isRequired }).isRequired
};

const defaultProps = {
    className: '',
};

class ActivityIconGeneral extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            templateStoreState: TemplateStore.getStateTemplateById(props.activity.template_id)
        };

        this.unsubscribes = [TemplateStore.listen(this.onTemplateStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onTemplateStoreChange(newState) {
        this.setState({ templateStoreState: TemplateStore.getStateTemplateById(this.props.activity.template_id) });
    }

    render() {
        if (!this.state.templateStoreState.initialized) {
            return null;
        }

        const template = this.state.templateStoreState.template;

        if (!template) {
            console.error(`ActivityIconGeneral: Template ID ${this.props.activity.template_id} not found in store.`);
            return null;
        }

        return (
            <img
                className={`act-icon ${this.props.className}`}
                src={`${GlobalConfig.StaticUrl}/img/templates/${template.icon}`}
                alt={`${template.name} ${Strings['en'].activity.ACTIVITY}`}
            />
        );
    }
}

ActivityIconGeneral.propTypes = propTypes;
ActivityIconGeneral.defaultProps = defaultProps;

export default ActivityIconGeneral;